import { VALID_LINK_REGEX } from '@/common/regex/regex.utils';
import { lightColors } from '@pendo/less-variables/lib/colors/light-colors/colors.js';
import { cssColorCode } from '@/utils/color';

/* eslint-disable internal-rules/no-hardcoded-colors */
const TRIMMED_FONT_COLORS = [
    'palette-gray-100',
    'palette-gray-70',
    'palette-blue-90',
    'palette-green-90',
    'palette-yellow-100',
    'palette-red-70',
    'palette-magenta-80',
    'palette-purple-70',
];
/* eslint-enable internal-rules/no-hardcoded-colors */

export const FONT_COLORS = TRIMMED_FONT_COLORS.map((color) => `var(--${color})`);

export const FALLBACK_URL = 'https://www.pendo.io/404';

/* eslint-disable array-callback-return*/
export function sanitizeContent (node) {
    if (node.content) {
        return node.content.map(sanitizeContent).some((val) => val);
    }

    // perform color correction
    if (node.type === 'text') {
        if (!node.marks) {
            node.marks = [];
        }

        const hasColorTextStyle = node.marks.some((mark) => {
            return mark.type === 'textStyle' && mark.attrs?.color;
        });

        if (!hasColorTextStyle) {
            const emptyColorIndex = node.marks.findIndex((mark) => {
                return mark.type === 'textStyle' && mark.attrs?.color === '';
            });

            if (emptyColorIndex !== -1) {
                node.marks[emptyColorIndex].attrs.color = 'var(--palette-gray-100)';
            } else {
                node.marks.push({
                    type: 'textStyle',
                    attrs: {
                        color: 'var(--palette-gray-100)',
                    },
                });
            }
        } else {
            node.marks.map((mark) => {
                if (mark.type === 'textStyle' && mark.attrs?.color) {
                    if (mark.attrs.color.startsWith('var')) {
                        return mark;
                    }

                    const rgb = cssColorCode(mark.attrs.color);

                    if (!rgb) {
                        mark.attrs.color = 'var(--palette-gray-100)';
                    } else {
                        const closestColor = findClosestColor(rgb);
                        mark.attrs.color = `var(--${closestColor})`;
                    }
                }
            });
        }
    }

    // sanitize links
    if (node.marks) {
        node.marks.map((mark) => {
            if (mark.type === 'link') {
                if (!mark.attrs.href.match(VALID_LINK_REGEX)) {
                    mark.attrs.href = FALLBACK_URL;
                }
            }
        });
    }
}

function findClosestColor (rgb) {
    let minDistance = Infinity;
    let closestColor;

    const richTextToolbarColors = getRichTextToolbarColors();

    Object.keys(richTextToolbarColors).forEach((key) => {
        const colorRgb = richTextToolbarColors[key];
        const distance = Math.sqrt(
            ((rgb.r - colorRgb.r) ** 2) +
            ((rgb.g - colorRgb.g) ** 2) +
            ((rgb.b - colorRgb.b) ** 2),
        );

        if (distance < minDistance) {
            minDistance = distance;
            closestColor = key;
        }
    });

    return closestColor;
}

function getRichTextToolbarColors () {
    const richTextToolbarColors = {};

    TRIMMED_FONT_COLORS.forEach((color) => {
        richTextToolbarColors[color] = cssColorCode(lightColors[color]);
    });

    return richTextToolbarColors;
}
